module.exports = __webpack_public_path__ + "img/arrow1.6d2dcea7.png";